import PropTypes from "prop-types";
import {
  StyledContainer,
  StyledTitleBox,
  IconContainer,
  TextContainer,
  StyledHeading,
  StyledSubHeading,
  StyledButton,
  ActionsContainer,
} from "./PageTitle.styles";

/**
 * Shared page heading — icon tile, title, subtitle, and optional primary action.
 * Pass `buttonDetails` for a contained CTA, or `action` for custom controls.
 */
const PageTitle = ({ title, subTitle, icon, buttonDetails, action }) => {
  return (
    <StyledContainer>
      <StyledTitleBox>
        {icon ? <IconContainer>{icon}</IconContainer> : null}
        <TextContainer>
          <StyledHeading>{title}</StyledHeading>
          {/* {subTitle ? <StyledSubHeading>{subTitle}</StyledSubHeading> : null} */}
        </TextContainer>
      </StyledTitleBox>
      {action != null || buttonDetails ? (
        <ActionsContainer>
          {action != null ? action : null}
          {buttonDetails ? (
            <StyledButton
              variant="contained"
              onClick={buttonDetails.onClick}
              disabled={buttonDetails.disabled}
            >
              {buttonDetails.label}
            </StyledButton>
          ) : null}
        </ActionsContainer>
      ) : null}
    </StyledContainer>
  );
};

PageTitle.propTypes = {
  title: PropTypes.node,
  subTitle: PropTypes.node,
  icon: PropTypes.node,
  buttonDetails: PropTypes.shape({
    label: PropTypes.node,
    onClick: PropTypes.func,
  }),
  action: PropTypes.node,
};

PageTitle.defaultProps = {
  title: "",
  subTitle: undefined,
  icon: undefined,
  buttonDetails: undefined,
  action: undefined,
};

export default PageTitle;
